import {
  Component,
  AfterViewChecked,
  OnInit,
} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {CompanyService} from "../services/company-service/company-service";
import {CategoryService} from "../services/category/category.service";
import {MatHeaderRow} from "../../../node_modules/@angular/material/typings/table/row";
import {ServiceItemDetailVM} from "../models/ServiceItemDetailVM";
import {TranslateService} from "ng2-translate";
import { Title,Meta } from '@angular/platform-browser';
import {PermissionService} from "../services/permission/permission.service";


/**
 * We're loading this component asynchronously
 * We are using some magic with es6-promise-loader that will wrap the module with a Promise
 * see https://github.com/gdi2290/es6-promise-loader for more info
 */


@Component({
  selector: 'book',
  template: require('./book.template.html'),
  styles: [require('./book.component.css')]
  // providers: [PermissionService]

})
export class BookComponent implements OnInit , AfterViewChecked {

  public serviceItem:ServiceItemDetailVM;
  public inIframe=false;
  public canBookOnline=true;
  public appVersion:string='v1';
  servantId: number;
  public isSubscriptionStatusValid : boolean;
  public isAzadTech : boolean = false;

  constructor(public companyService:CompanyService,
              public categoryService:CategoryService,
              public activatedRoute:ActivatedRoute,
              public translate:TranslateService,
              private pageTitle:Title,
              private permissionService: PermissionService

  ) {

    translate.setDefaultLang('fa');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('fa');
    this.isSubscriptionStatusValid = true;

  }

  public ngOnInit() {
    let parent=this;
    this.inIframe=this.companyService.inIframe();

    this.companyService.getCompanyInfo().subscribe(function(com){
      if(com.appVersion )
        parent.appVersion=com.appVersion;

      //check azadTech -- must change in future
      if(com.keyUrl.toLowerCase() == 'azadtech')
        parent.isAzadTech = true;
      //...........................................

      parent.permissionService.isSubscriptionValid(com.keyUrl).subscribe(res => {
        parent.isSubscriptionStatusValid = res;
      });

    })

    this.activatedRoute.queryParams.subscribe((params:Params) => {
      let id = params['id'];
      this.servantId = params['servantId'];

      this.getSpaceDetail(id);
    });
    this.activatedRoute.params.subscribe((params:Params) => {
      let id = params['id'];
      this.getSpaceDetail(id);
    });

  }

  getSpaceDetail(id:number) {
    this.categoryService.getServiceItemDetailById(id).subscribe((sd:ServiceItemDetailVM)=> {
      this.serviceItem = sd;
      if(this.serviceItem.serviceStatus!='PUBLISH')
          this.canBookOnline=false;
      if(!this.isSubscriptionStatusValid)
        this.canBookOnline=false;
     this.setPageTitle();
      window.scrollTo(0, 0);
    });
  }
  ngAfterViewChecked() {

  }


  public setPageTitle()
  {
    this.pageTitle.setTitle(this.serviceItem.itemTitle);
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/+book/book.component.ts